import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { UpdateRegisteredUserPort } from '../../../domain/commerce-registry/ports/update-registered-user.port';
import type {
  RegisterUserResult,
  UpdateRegisteredUserPayload,
} from '../../../domain/commerce-registry/models/register-user.model';
import { ENVIRONMENT } from '../../../../environments/environment';

const CODE_OK = 100;

interface UsuarioPutApiResponse {
  code?: number;
  message?: string;
  data?: unknown;
}

@Injectable()
export class UpdateRegisteredUserApiAdapter extends UpdateRegisteredUserPort {
  constructor(private readonly http: HttpClient) {
    super();
  }

  update(payload: UpdateRegisteredUserPayload, bearerToken: string): Observable<RegisterUserResult> {
    const base = ENVIRONMENT.apiMobileUrl?.trim();
    const token = bearerToken?.trim();
    if (!base) {
      return of<RegisterUserResult>({
        outcome: 'error',
        message: 'Servicio de actualización no configurado',
      });
    }
    if (!token) {
      return of<RegisterUserResult>({
        outcome: 'error',
        message: 'Sesión de actualización no válida. Vuelve a validar tus datos.',
      });
    }

    const url = `${base.replace(/\/$/, '')}/api/usuarios`;
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.put<UsuarioPutApiResponse>(url, payload, { headers }).pipe(
      map((res) => this.mapResponse(res)),
      catchError(() =>
        of<RegisterUserResult>({
          outcome: 'error',
          message: 'No pudimos actualizar tus datos. Intenta de nuevo.',
        }),
      ),
    );
  }

  private mapResponse(res: UsuarioPutApiResponse): RegisterUserResult {
    const code = res?.code;
    const message = typeof res?.message === 'string' ? res.message.trim() : '';
    if (code === CODE_OK) {
      return {
        outcome: 'success',
        message: message || 'Tus datos se actualizaron correctamente.',
      };
    }
    return {
      outcome: 'error',
      message: message || 'No se pudo actualizar el perfil.',
    };
  }
}
